module.exports = "/fonts/MetaPro-Norm.woff?f59fc694e48c8edccfb4b0d0b589c261";